interface Callsite {
  getFunctionName(): string;
  getFileName(): string;
  getLineNumber(): number;
  getColumnNumber(): number;
}

export function callsites(): Callsite[] {
  try {
    const _prepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = (_, stack) => stack;
    const stack = new Error().stack;
    Error.prepareStackTrace = _prepareStackTrace;

    if (typeof stack === "string") {
      return stack
        .split("\n")
        .splice(1)
        .reduce((acc, line) => {
          const matches = line.match(/^(.*)@(.*):(\d+):(\d+)$/);

          if (matches) {
            const [_, functionName, fileName, lineNumber, columnNumber] =
              matches;

            acc.push({
              getFunctionName: () => functionName,
              getFileName: () => fileName,
              getLineNumber: () => Number(lineNumber),
              getColumnNumber: () => Number(columnNumber),
            });
          }

          return acc;
        }, [] as Callsite[]);
    }

    return (stack as unknown as Callsite[]).splice(1);
  } catch (e) {
    return [];
  }
}
